import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.header`
  display: ${({ hidden }) => (hidden ? 'none' : 'flex')};
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: transparent;
  padding: 15px 30px;
  z-index: 99;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;

  &.scrolled {
    box-shadow: 0px 15px 15px #00000050;
    background: ${props => props.background_color ? `${props.background_color}` : "#202020"};
  }

  a:hover, .sugestoes:hover {
      transition: all .3s ease;
      opacity: .8;
  }

  .sugestoes {
      position: relative;
      background: #fff;
      color: #000 !important;
      opacity: 1 !important;
      padding: 5px 10px !important;
      margin-left: 20px;
  }

  .sugestoes::before {
      content: '';
      position: absolute;
      top: 0;
      left: -12px;
      height: 100%;
      width: 2px;
      background: #fff;
      opacity: .6;
  }

  .logo-mobile {
      display: none;
  }

  @media (max-width: 800px) {

      padding: 10px 20px;

      .container-profile a {
          padding: 5px 5px;
      }
  }

  @media (max-width: 700px) {

      .sugestoes {
          display: none !important;
      }
  }

  @media (max-width: 600px) {
      
      padding: 10px;

      .logo-desktop {
          display: none;
      }

      .logo-mobile {
          display: block;
      }

      section {
          display: flex;
      }
  }
`;

export const Nav = styled.nav`

  .div-logo-links {
    display: flex;
    align-items: center;
  }

  .div-logo-links .section-links-nav {
    display: flex;
    align-items: center;
    margin-left: 50px;
  }

  .section-links-nav a {
    color: #ccc;
    text-decoration: none;
    font-weight: 600;
    margin-right: 15px;
    transition: all .3s ease;
  }

  .section-links-nav a:hover {
    color: #fff;
  }

  @media (max-width: 600px) {
    padding: 10px;

    .div-logo-links .section-links-nav {
      margin-left: 10px;
      font-size: .7rem;
    }
  }
`;

export const Logo = styled(Link)`
  position: relative;
  display: flex;
  align-items: end;
  color: ${({ background }) => (background == 'dark' ? '#fff' : '#333333')};
  background: ${({ background }) => (background == 'dark' ? '#000' : 'unset')};
  font-weight: 600;
  filter: drop-shadow(0 0 5px rgba(0, 0, 0, .7));
  text-transform: capitalize;
  text-decoration: none;
  margin-right: 20px;
  border-radius: 5px;
  transition: all .3s ease;

  img {
    height: 40px;
  }

  .span-pro {
    color: #fff;
    margin-left: -5px;
    font-size: .9rem;
  }

  &:hover {
    opacity: .7;
  }

  @media (max-width: 600px) {

    img {
      height: 30px;
    }

    .span-pro {
      font-size: .6rem;
    }

  }
  
`;

export const Divider = styled.div`
  flex-grow: 1;
  height: 1px;
  background-color: #dddddd;
  margin: 0 10px;

  @media (max-width: 800px) {
    display: none;
  }
`;

export const HamburgerIcon = styled.div`
  display: none;
  flex-direction: column;
  cursor: pointer;
  font-size: 1.5rem;

  @media (max-width: 800px) {
    display: flex;
  }
`;

export const NavMenu = styled.div`

  display: flex;
  align-items: center;

  @media (max-width: 800px) {

    display: ${({ open }) => (open ? 'flex' : 'none')};
    flex-direction: column;
    align-items: flex-start;
    position: absolute;
    top: 45px;
    right: 20px;
    background-color: #303030;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.8);
    padding: 5px;
    width: max-content;
    width: 200px;
    border-radius: 5px;
    z-index: 999;

  }
`;

export const NavLink = styled(Link)`
  display: flex;
  align-items: center;
  color: ${({ background }) => (background == 'dark' ? '#fff' : '#bbb')};
  background: ${({ background }) => (background == 'dark' ? '#000' : 'unset')};
  font-weight: 600;
  font-size: .9rem;
  text-transform: capitalize;
  text-decoration: none;
  padding: 8px;
  margin-right: 10px;
  transition: color 0.3s ease, background-color 0.3s ease;
  border-radius: 5px;

  span {
    margin-left: 5px;
  }

  .show-mobile {
    display: none;
  }

  img {
    width: 35px;
    margin-right: 5px;
    border-radius: 50%;
    border: 1px solid #000;
    opacity: .6;
  }

  &:hover {
    color: #fff;
  }
  
  &:hover img {
    opacity: 1;
  }

  @media (max-width: 800px) {
    display: flex;
    padding: 10px;
    margin: 0 0 5px 0;
    width: 100%;
    color: #fff;

    img {
      opacity: 1;
    }

    .show-mobile {
      display: block;
    }
  }
`;

export const ContainerLogin = styled.div `

  display: flex;
  align-items: center;

  a:first-child {
    margin-right: 20px;
  }

  @media (max-width: 600px) {

    a:first-child {
      margin-right: 10px;
    }

  }

`

export const LinkLogin = styled(Link) `

  display: flex;
  align-items: center;
  color: ${({ background }) => (background == 'dark' ? '#fff' : '#333333')};
  background: ${({ background }) => (background == 'dark' ? '#000' : 'unset')};
  font-weight: 600;
  text-transform: capitalize;
  text-decoration: none;
  padding: 8px;
  transition: color 0.3s ease, background-color 0.3s ease;
  border-radius: 5px;

  &:hover {
    color: #ffffff;
    background-color: #505050;
  }

`

export const Menu = styled.menu `
    
  display: flex;
  align-items: center;
  margin-left: 40px;

  .show-mobile {
    display: none;
  }

  @media (max-width: 600px) {

    .show-mobile {
      display: block;
    }

  }

  div {
    display: flex;
  }

  &.nav a {
    color: #fff;
    text-decoration: none;
    font-size: .8rem;
    font-weight: bold;
    text-transform: uppercase;
    margin-right: 5px;
    padding: 0 2px;
    border-radius: 50px;
    opacity: .6;
    transition: all .3s ease;
  }

  &.nav a:hover {
      opacity: 1;
  }

  &.nav a:last-child {
      margin-right: 0;
  }

  &.nav a i {
      display: none;
  }

  .search-link {
      color: #fff;
      font-size: 18px;
      font-weight: 600;
      padding-top: 3px;
      border-radius: 50%;
      padding: 5px 10px;
      transition: all .2s ease;
  }

  .search-link:hover {
      background-color: #303030;
      opacity: 1;
  }

  .button-open-notifications {
      position: relative;
      background: none;
      font-size: 1.3rem;
      height: 35px;
      width: 35px;
      border-radius: 50%;
      border: 1px solid transparent;
      color: #fff;
      margin-right: 5px;
      cursor: pointer;
      transition: all .2s ease;
  }

  .button-open-notifications:hover {
      background-color: #303030;
  }

  .span-new-notification {
      position: absolute;
      top: 2px;
      right: 2px;
      background: #f00;
      border: 1px solid #181818;
      font-size: .5rem;
      padding: 1px 5px;
      border-radius: 50%;
      animation: flutuar 2s infinite;
      transition: all .3s ease;
      z-index: 1;
  }

  .container-profile {
      position: relative;
      display: flex;
      align-items: center;
      background: unset;
      border: none;
      cursor: pointer;
      margin: 0 10px;
      transition: all .3s ease;
  }

  .container-profile:hover {
      opacity: .8;
  }

  .container-profile a {
      display: flex;
      align-items: center;
      background: #fff;
      color: #181818;
      text-decoration: none;
      padding: 8px 10px;
      font-weight: 600;
      font-size: .8rem;
      border-radius: 5px;
      transition: all .3s ease;
  }

  .profile-img {
      min-width: 35px;
      max-width: 35px;
      min-height: 35px;
      max-height: 35px;
      background: #252525;
      border-radius: 5px;
  }

  .link-login img {
      width: 15px;
      margin-right: 5px;
  }

  @keyframes flutuar {
      30% {
          transform: translatey(-5px);
      }
  }


  @media (max-width: 600px) {

      margin: 0;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      
      &.nav {
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 75px;
          padding-top: 10px;
          display: flex;
          align-items: center;
          background-image: linear-gradient(to top, #050505, #050505,  #00000000);
      }
      
      &.nav {
          display: flex;
          justify-content: space-around;
          margin-left: 0;
          width: 100%;
          -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      }

      &.nav a {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          text-transform: initial;
          font-size: .6rem;
          width: 45px;
          height: 45px;
          color: #fff;
          border-radius: 50px;
          opacity: .8;
          transition: all .3s ease;
      }

      &.nav a:hover {
          background: #252525;
          color: #fff;
      }
      
      &.nav a i {
          display: block;
          font-size: .8rem;
          margin-bottom: 3px;
      }
  }

  @media (max-width: 400px) {
      #infatil-link {
          display: none;
      }
  }

`

export const ContainerMenu = styled.div `
    display: flex;
    align-items: center;
`